import Swiper from "swiper";
import { Mousewheel } from "swiper/modules";
import 'swiper/swiper-bundle.min.css';

Swiper.use([Mousewheel]);

document.addEventListener('alpine:init', () => {
    Alpine.data('swiper', () => ({
        swiper: null,
        leave: false,
        swiperData: [],
        initialStep(step){
            this.renderSwiper(step-1);
        },
        addData(data){
            this.swiperData.push({
                title: data.Swiper.PrimaryHeading.Text,
                description: data.Swiper.Description.Text,
                imagePath: '/media/'+data.Swiper.BackgroundImage.Paths[0],
                url: data.Swiper.Link.Text,
                number: ('0' + data.Swiper.Number.Value).slice(-2),
                colourHead: data.Swiper.Style.Text,
                colourDesc: data.Swiper.ToggleColour.Value
            });
            this.orderByNumber();
        },
        orderByNumber(){
            this.swiperData.sort((a, b) => a.number - b.number);
        },
        renderSwiper(step){
            const swiper = document.querySelector('.swiper')
            const newSwiper = new Swiper(swiper, {
                effect: 'coverflow',
                mousewheel: true,
                grabCursor: true,
                loop: true,
                slidesPerView: 1,
                spaceBetween: 10,
                initialSlide: step,
                breakpoints:{
                    768:{
                        slidesPerView: 5,
                        initialSlide: step,
                    }
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                
            })
            newSwiper.mousewheel.enable();
        },
        
    }))
});
